export type 마켓봄_업데이트_소식_카드_정보 = {
  제목: string;
  날짜: `${string}. ${string}. ${string}`;
  설명: string;
  링크: string;
};
export type 마켓봄_업데이트_소식_정보 = {
  카드_정보_목록: [
    마켓봄_업데이트_소식_카드_정보,
    마켓봄_업데이트_소식_카드_정보
  ][];
};

export const 마켓봄_업데이트_소식_카드_정보_목록: [
  마켓봄_업데이트_소식_카드_정보,
  마켓봄_업데이트_소식_카드_정보
][] = [
  [
    {
      제목: "마켓봄, 자체 채팅 기능 출시",
      날짜: "2025. 09. 17",
      설명: "카카오톡, 문자, 전화 등 외부 메신저로 이루어지던\n수발주를 통합관리 하기 위한 채팅 기능 출시",
      링크: "https://www.asiatime.co.kr/article/20250917500133",
    },
    {
      제목: "마켓봄으로 새벽 근무를 없엔 방법!",
      날짜: "2025. 08. 25",
      설명: "마켓봄으로 새벽 근무를 없엔 (주)프레쉬몰\n마켓봄을 이용한 수발주 자동화 도입",
      링크: "https://blog.naver.com/marketbom/223982618793",
    },
  ],
  [
    {
      제목: "하루에 3시간 아끼는 마켓봄 자동화",
      날짜: "2025. 08. 14",
      설명: "업무 시간을 확! 줄여주는\n마켓봄 자동화 기능 3가지 확인하기",
      링크: "https://blog.naver.com/marketbom/223970622927",
    },
    {
      제목: "실무자 만족 200% 마켓봄 추천 기능",
      날짜: "2025. 07. 30",
      설명: "업무 효율을 확실하게! 높여주는\n마켓봄만의 특별한 기능 5가지를 확인해 보세요.",
      링크: "https://blog.naver.com/marketbom/223952446299",
    },
  ],
];
